var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("SeaExport.BookingAudit"),
        width: "600px",
        "custom-class": "cargo-form-dialog",
        "close-on-click-modal": false
      },
      on: { close: _vm.handleClose }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "cargo-form",
          attrs: { "label-width": "90px", "label-position": "left" }
        },
        [
          _vm.isDifferentJobOrBusinessFieldValues
            ? _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "auto-width",
                          attrs: { "label-width": "0" }
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-warning",
                            staticStyle: {
                              color: "#e6a23c",
                              "margin-left": "5px"
                            }
                          }),
                          _c("span", { staticStyle: { "font-size": "12px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Message.DifferentJobOrBusinessFieldValues"
                                )
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.OperationCompany")) + "："
                          )
                        ]
                      ),
                      _c("cargo-office-select", {
                        attrs: {
                          no: "opOffice",
                          clearable: false,
                          "have-hq": false,
                          disabled: _vm.isTrustFrom,
                          "office-id": Number(_vm.job.opOffice),
                          "tag-name": "code",
                          tooltip: ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opOffice = p.value
                            _vm.officeChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Operation") + "：" } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "op",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.job.op || "",
                          placeholder: _vm.differentForm.op
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.Operation")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.op = p.value
                            _vm.differentForm.op = true
                            _vm.opChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          class: _vm.isBatchUpdate ? "" : "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.OperationDepartment")) +
                              "："
                          )
                        ]
                      ),
                      _c("cargo-department-select", {
                        attrs: {
                          no: "opDepartment",
                          "office-id":
                            Number(_vm.job.opOffice) ||
                            _vm.$store.getters.currentOfficeId,
                          "department-id": Number(_vm.job.opDepartment),
                          placeholder: _vm.differentForm.opDepartment
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.OperationDepartment")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opDepartment = p.value
                            _vm.differentForm.opDepartment = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomerService") + "："
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "csr",
                        attrs: {
                          no: "csr",
                          "method-params": {
                            officeId:
                              _vm.isTrustFrom || _vm.job.salesOffice === 1
                                ? _vm.job.opOffice
                                : _vm.job.salesOffice,
                            category: "role",
                            shape: "csr"
                          },
                          "default-value": _vm.job.csr || "",
                          placeholder: _vm.differentForm.csr
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.CustomerService")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csr = p.value
                            _vm.differentForm.csr = true
                            _vm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Documents") + "：" } },
                    [
                      _c("cargo-user-select", {
                        ref: "dc",
                        attrs: {
                          no: "dc",
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "doc"
                          },
                          "default-value": _vm.job.dc || "",
                          placeholder: _vm.differentForm.dc
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.Documents")
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dc = p.value
                            _vm.differentForm.dc = true
                            _vm.dcChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ContractRateProperty") + "："
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "bookingTerm",
                            clearable: false,
                            size: "mini",
                            placeholder: _vm.differentForm.bookingTerm
                              ? _vm.$t("SeaExport.PleaseSelect")
                              : _vm.$t("Message.PreserveOriginalValue") +
                                _vm.$t("SeaExport.ContractRateProperty")
                          },
                          on: {
                            change: function(p) {
                              _vm.differentForm.bookingTerm = true
                              _vm.bookingTermChangeHandler
                            }
                          },
                          model: {
                            value: _vm.job.bookingTerm,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "bookingTerm", $$v)
                            },
                            expression: "job.bookingTerm"
                          }
                        },
                        _vm._l(_vm.bookingTerms, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              no: item.code,
                              label: item.chineseName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "red-input",
                      attrs: { label: _vm.$t("SeaExport.BookingAgent") + "：" }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "bookingAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          filterable: "",
                          "method-params": {
                            bookingAgent: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.job.bookingAgent || "",
                          placeholder: _vm.differentForm.bookingAgent
                            ? _vm.$t("CargoMsg.Cargo_keyWordsTip")
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.BookingAgent")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.bookingAgent = p.value
                            _vm.differentForm.bookingAgent = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.$t("SeaExport.ShippingCompanyContractNo") + "："
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "scNo",
                          placeholder: _vm.differentForm.scNo
                            ? ""
                            : _vm.$t("Message.PreserveOriginalValue") +
                              _vm.$t("SeaExport.ShippingCompanyContractNo")
                        },
                        on: {
                          change: function(p) {
                            _vm.differentForm.scNo = true
                          }
                        },
                        model: {
                          value: _vm.job.scNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "scNo", $$v)
                          },
                          expression: "job.scNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Remarks") + "：" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", no: "remarks", rows: 2 },
                        model: {
                          value: _vm.job.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "remarks", $$v)
                          },
                          expression: "job.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticStyle: { padding: "10px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "confirm" },
              on: { click: _vm.handleSubmit }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "cancel" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }